import { ColumnConfig } from '../../molecules/table/columnSettings';

export const AUDIT_DASHBOARD_STORAGE_KEY = 'audit_dashboard_column_visibility';

export const AUDIT_DASHBOARD_DEFAULT_COLUMNS: ColumnConfig[] = [
  { id: 'aggregateShipmentType', label: 'Type', isVisible: true }, // Icons
  { id: 'invoiceNumber', label: 'Invoice No.', isVisible: true, isLocked: true }, // Always visible
  { id: 'date', label: 'Date', isVisible: true },
  { id: 'shipmentNumber', label: 'Ship. No', isVisible: true },
  { id: 'tradeLane', label: 'Trade Lane', isVisible: true },
  { id: 'service', label: 'Service', isVisible: true },
  { id: 'totalAmount', label: 'Total Amount', isVisible: true },
  { id: 'deviationAmount', label: 'Deviation Amount', isVisible: true },
  { id: 'status', label: 'Status', isVisible: true },
  { id: 'incoterm', label: 'Incoterm', isVisible: true },
  { id: 'billedEntity', label: 'Billed Entity', isVisible: true },
  { id: 'shipper', label: 'Shipper', isVisible: true },
  { id: 'consignee', label: 'Consignee', isVisible: true },
  { id: 'pendingItems', label: 'Pending Items', isVisible: true, isLocked: true }, // Pending Item locked
  { id: 'actions', label: 'Actions', isVisible: true, isLocked: true }, // Actions menu
];
